import React, { useRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import _ from "lodash";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Table,
    Container,
    Row,
    Col,
    Button,
    UncontrolledDropdown,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    InputGroup,
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
//import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ReduxBlockUi from "react-block-ui/redux";
import "react-block-ui/style.css";
import * as Helper from "../../../utils/Helper";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/bbs/MessageRedux";
import DetailsService from "../../../services/screens/admin/bbs/DetailsService";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";
import { Pagination } from "antd";
import "antd/dist/antd.css";
import { ClearOutlined, CommentOutlined, PictureOutlined } from "@ant-design/icons";
import { Upload, Icon } from "antd";
import HTMLView from "../../../components/ui/HTMLView";

const uid = UIDs.screens.admin.bbs.message;

class MessageScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.DELETE_ASYNC]: { done: this._handleAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.LIKE_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.DELETE_LIKE_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.REPLY_ASYNC]: { done: this._handleAddReplySuccess, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        // call load screen view to update analytics
        let { searchVO } = this.props.localState;
        searchVO = { ...searchVO, partnerId: this.props.partnerId };
        this.props.loadScreenViewAsync(searchVO);
    }

    render() {
        const { messageList, totalCount, messageId } = this.props.localState;
        return (
            <>
                <Header />
                <Container className="mt--7 aic-list-style" fluid>
                    <Row style={{marginTop:20}}>
                        <Col>
                            <Card className="shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row style={{marginBottom:10, marginTop:10, paddingBottom:10}}>
                                        <Col xs="6">
                                            <h2>{this.props.t("message")}</h2>
                                        </Col>
                                        <Col textAlign="right">
                                            <Button
                                                style={{float:"right"}}
                                                color="default"
                                                onClick={this._handelBack}
                                                size="sm">
                                                {this.props.t("back")}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>

                                <Row style={{marginRight:0, marginLeft:0, borderBottom:"1px solid rgba(0, 0, 0, 0.05)", marginBottom:10, marginTop:-10, paddingBottom:30}}>
                                    <Col xs="6" style={{paddingLeft:25}}>
                                        {totalCount > 0 ?
                                            <ClearOutlined style={{fontSize:20, cursor:"pointer"}} onClick={()=>{this._handleDelete({messageId: "", deleteAll:true})}} />
                                        :null}
                                    </Col>
                                    <Col textAlign="right">
                                        <nav aria-label="..." style={{ textAlign: "right" }}>
                                            {this._renderPagination()}
                                        </nav>
                                    </Col>
                                </Row>
                                <CardBody style={{marginTop:-10}}>
                                    {this._renderList()}
                                </CardBody>
                                <CardFooter className="py-4">
                                    <nav aria-label="..." style={{ textAlign: "right" }}>
                                        {this._renderPagination()}
                                    </nav>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }

    _renderList() {
        const { messageList, messageId } = this.props.localState;
        return(
        <>
            {messageList.map((item, msgIdx)=>{
                const {id, actionType, fromUserId, fromUserIcon, fromUserName, addedOn, postInfo, replyInfo, addRelyInfo = []} = item;
                const newReplyInfoData = replyInfo && replyInfo.data ? JSON.parse(replyInfo.data) : null;
                const {files:addRelyInfoFiles = []} = newReplyInfoData ? newReplyInfoData : {};

                let titleDesc = '';
                if (item.actionType === 'REPLY') {
                    if (item.toReplyInfo) {
                        titleDesc = this.props.t('replyYourReply');
                    } else {
                        titleDesc = this.props.t('replyYourPost');
                    }
                }else{
                    if (item.toReplyInfo) {
                        titleDesc = this.props.t('likeYourReply');
                    } else {
                        titleDesc = this.props.t('likeYourPost');
                    }
                }


                return(
                    <>
                    <Row>
                        <Col>
                            <div>
                                <div style={{float:"left"}}>
                                    {this._renderUserIcon(fromUserIcon, 40, 40)}
                                </div>
                                <div style={{float:"left", paddingTop:10, marginLeft:10}}>
                                    <span style={{fontWeight:"bold"}}>{fromUserName}</span> {titleDesc}
                                </div>
                                <div style={{float:"right", paddingTop:10}}>
                                    {Helper.convertToLocalString(addedOn)}
                                    <i class="fa fa-trash" style={{fontSize:12,cursor:"pointer", marginTop:-4, marginLeft:5}} onClick={()=>{this._handleDelete({messageId: id, deleteAll: false})}}></i>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {newReplyInfoData && (newReplyInfoData.text || newReplyInfoData.html) ? <Row style={{marginTop:10}}>
                        <Col>
                            {newReplyInfoData.html ?
                             (<HTMLView html={newReplyInfoData.html}/>) :
                             (<div>{newReplyInfoData.text}</div>)}
                        </Col>
                    </Row> : null}
                    {addRelyInfoFiles && addRelyInfoFiles.length>0 ? <Row>
                        <Col>
                            {addRelyInfoFiles && addRelyInfoFiles.length>0 ? addRelyInfoFiles.map((img)=>{
                                return(
                                    <a href={Helper.convertToFileServerPath(img)} target="_blank">
                                        <img src={Helper.convertToFileServerPath(img)} style={{width:50, height:50, borderRadius:2, marginRight:10, marginTop:10}} />
                                    </a>
                                )
                            }): null}
                        </Col>
                    </Row> : null}
                    {addRelyInfo && addRelyInfo.length > 0 ?
                        addRelyInfo.map((addReply)=>{
                            const newData = addReply && addReply.data ? JSON.parse(addReply.data):null;
                            const {files = []} = newData ? newData : {};
                            return(
                                <Row>
                                    <Col style={{marginTop:20}}>
                                        <div style={{marginLeft:50}}>
                                            <div style={{display:"flex", alignItems:"center"}}>
                                                {this._renderUserIcon(addReply.fromUserIcon, 40, 40)}&nbsp;&nbsp;
                                                <span style={{fontWeight:"bold"}}>{addReply.fromUserName}</span>&nbsp;&nbsp;
                                                {this.props.t("reply")}&nbsp;&nbsp;
                                                {addReply.fromUserId === addReply.toUserId ? null : <span style={{fontWeight:"bold"}}>{addReply.toUserName}</span>}
                                                {newData && (newData.text || newData.html) ?
                                                 (<>: {newData.html ? (<HTMLView html={newData.html}/>) : newData.text}</>) : ""}
                                            </div>
                                            <div style={{clear:"both"}}>
                                                {files && files.length>0 ? files.map((img)=>{
                                                    return(
                                                        <a href={Helper.convertToFileServerPath(img)} target="_blank">
                                                            <img src={Helper.convertToFileServerPath(img)} style={{width:50, height:50, borderRadius:2, marginRight:10, marginTop:10}} />
                                                        </a>
                                                    )
                                                }): null}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )
                        })
                    :null}
                    <Row style={{borderBottom: msgIdx >= messageList.length-1 ? "0px" : "1px solid rgba(0, 0, 0, 0.05)", marginBottom:10, marginTop:10, paddingBottom:10}}>
                        <Col xs="12">
                            <div style={{display:"flex", backgroundColor:"#F7F7F7", flexDirection:"column", padding: 10, borderRadius:6}}>
                                <div style={{display:"flex", alignItems: "center"}}>
                                    {this._renderUserIcon(postInfo.userIcon, 30, 30)}&nbsp;&nbsp;<span style={{fontWeight:"bold"}}>{postInfo.userName}</span>
                                </div>
                                <div style={{marginTop:10}}><Link to={`/admin/bbs/${postInfo.id}/details`}>{postInfo.title}</Link></div>
                                <div style={{clear:"both", marginTop:10}}>
                                    <div style={{float:"left"}}>
                                        {
                                            postInfo.tags ? postInfo.tags.split("\n").map((item)=>{
                                                return(
                                                    <div style={{float:"left", backgroundColor:"#EFF5FF", color:"#2580EB", borderRadius:4, padding:"2px 5px", marginRight:10}}>{item}</div>
                                                )
                                            })
                                            :null
                                        }
                                    </div>
                                    <div style={{float:"right"}}>{postInfo.className}</div>
                                </div>
                            </div>
                        </Col>
                        {actionType === "REPLY" ?
                            replyInfo ?
                                <>
                                    <Col xs="12">
                                        <div style={{float:"left", cursor:"pointer"}} onClick={()=>{messageId === id ? this.props.setMessageId("") : this.props.setMessageId(id)}}><CommentOutlined style={{fontSize:18, marginRight:10, marginTop:10}}/></div>
                                        <div style={{float:"left", marginTop:10, color:"#979797", cursor: "pointer"}}
                                            onClick={()=>{replyInfo.isMyLike ? this.props.deleteLikeAsync({messageId: id, postId: postInfo.id, replyId: replyInfo.id, src:"replyInfo"}) : this.props.likeAsync({messageId: id, postId: postInfo.id, replyId: replyInfo.id, src:"replyInfo"})}}
                                        >
                                            <i className="fa fa-thumbs-up" style={{marginRight:5}} />
                                            {replyInfo.isMyLike ? this.props.t("liked") : this.props.t("like")}
                                        </div>
                                    </Col>
                                    {messageId === id ?
                                        <Col xs="12">
                                            <CommentForm
                                                {...this.props}
                                                postId = {postInfo.id}
                                                messageId={messageId}
                                                toUserId = {replyInfo.fromUserId}
                                                toReplyId = {replyInfo.toReplyId ? replyInfo.toReplyId : replyInfo.id}
                                                replyUserName = {replyInfo.fromUserName}
                                                onCancel={this._handleCancelComment}
                                                onSave={this._handleSave}
                                                isDisabled={this.isActionExecuting(ActionTypes.SAVE_ASYNC)}
                                            />
                                        </Col>
                                    : null}
                                </>
                            : null
                        : null}
                    </Row>
                    </>
                )
            })}
        </>
        )
    }

    //显示用户头像
    _renderUserIcon = (userIcon, width, height) =>{
        return(
            userIcon.isUseAvatar ?
                <div style={{float:"left", display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:16, fontWeight:700, backgroundColor:userIcon.avatarBackgroundColor, borderRadius:"100%", width:width, height:height, textAlign:"center"}}>
                    {userIcon.avatarName}
                </div>
            :
                <img
                    style={{ float:"left", height: height, width: width, borderRadius:"100%" }}
                    alt="..."
                    src={Helper.convertToFileServerPath(userIcon.photo)}
                />
        )
    }

    _renderPagination() {
        const { totalCount, searchVO } = this.props.localState;
        let pageIndex = searchVO.pageIndex;
        let pageSize = searchVO.pageSize;
        let pageElement = (
            <Pagination
                defaultCurrent={1}
                current={pageIndex}
                total={totalCount}
                defaultPageSize={pageSize}
                showTotal={total => this.props.t("total",{totalNum: total})}
                onChange={(pageIndex, pageSize) => { this._handlePage(pageIndex) }}
            />
        );
        return pageElement;
    }

    _handlePage = (i) => {
        const { searchVO } = this.props.localState;
        let pageIndex = i > 0 ? i : 1;
        let vo = { ...searchVO, partnerId: this.props.partnerId, pageIndex };
        this.props.loadScreenViewAsync(vo);
    };

    //删除贴子
    _handleDelete = (vo) => {
        confirmAlert({
            title: this.props.t("confirmToDelete"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.deleteAsync(vo);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    //取消评论
    _handleCancelComment = () => {
        this.props.setMessageId("");
    }

    //保存回复
    _handleSave = (data) => {
        let {postId, comments, toReplyId, files, toUserId, messageId} = data;
        let newData = {
            postId,
            replyId: toReplyId,
            toUserId,
            messageId,
            type: "TEXT",
            data: JSON.stringify({
                text: comments,
                files: files ? files.split(',') : [],
            })
        }

        confirmAlert({
           title: this.props.t("confirmToSave"),
           message: this.props.t("sureToDo"),
           buttons: [
               {
                   label: this.props.t("yes"),
                   onClick: () => {
                       data = { ...newData }
                       this.props.replyAsync(data);
                       this.props.setMessageId("");
                   }
               },
               {
                   label: this.props.t("no")
               }
           ]
        });
    }

    _handleAddReplySuccess = () => {
        this.displaySuccess(this.props.t("replySuccess"));
    };

    //返回
    _handelBack = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncDone = (kind) => {
        this.displaySuccess(this.props.t("operatorSuccess"));
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}


function CommentForm(props) {
    const { localState, replyUserName, postId, toReplyId, toUserId, messageId } = props;
    const submitCommentFormRef = useRef();
    const { register, handleSubmit, errors, setValue, clearError } = useForm();
    const [loading, setLoading] = useState(false);
    const uploadButton =  loading ? <Icon type="loading" style={{fontSize:33}} /> : <PictureOutlined style={{fontSize:33, cursor:"pointer", marginTop:-3}} />;
    const [state_files, setState_files] = useState([]);

    const uploadProps = {
        name: "fileData",
        multiple: false,
        showUploadList: false, // set to only upload one file
        customRequest: info => {
            startUpload(info.file, postId, uploadPicSuccessCallback);
        },
        onChange: info => {
            if (info.file.status === "uploading") {
                setLoading(true);
            }
        },
        //listType: "picture-card",
        //style:{padding: 0, border:0, height:40, width:40},
        beforeUpload: file => {
            const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
            if (!isJpgOrPng) {
                MessageBox.danger(props.t("uploadImageFormatLimited"));
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                MessageBox.danger(props.t("uploadImageSizeLimited", { fileSize: 5 }));
                return false;
            }
            return isJpgOrPng && isLt2M;
        }
    };

    const startUpload = (file, postId, uploadSuccessCallback) => {
        setLoading(true);
        DetailsService.uploadPhoto(
            file,
            postId,
            response => {
                uploadSuccessCallback(response);
                setLoading(false);
            },
            error => {
                setLoading(false);
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    };

    const uploadPicSuccessCallback = (data) => {
        const { virtualPath } = data;
        let newFiles = state_files || [];
        newFiles.push(virtualPath);
        setState_files(newFiles);
    };

    const removePic = (index) => {
        let newFiles = [];
        for(var i=0; i<state_files.length; i++){
            if(i !== index){
                newFiles.push(state_files[i]);
            }
        }
        setState_files(newFiles);
    }

    return (
        <form onSubmit={handleSubmit(props.onSave)}>
            <input name="messageId" hidden type="text" defaultValue={messageId} ref={register} />
            <input name="postId" hidden type="text" defaultValue={postId} ref={register} />
            <input name="toReplyId" hidden type="text" defaultValue={toReplyId} ref={register} />
            <input name="files" hidden type="text" value={state_files} ref={register} />
            <input name="toUserId" hidden type="text" value={toUserId} ref={register} />

            <Row style={{marginBottom:20, marginTop:10}}>
                <Col style={{display:"flex"}}>
                    <div style={{flex:1, clear:"both"}}>
                        <div style={{border:"1px solid rgba(0, 0, 0, 0.05)", borderRadius:6, padding:"10px 10px"}}>
                            <div style={{color:"#999999"}}>{props.t("reply")} {replyUserName}：</div>
                            <div style={{paddingRight:10}}>
                                <textarea style={{border:0, boxShadow:"none"}} name="comments" type="text" className="form-control" defaultValue={""}
                                    ref={register({ required: state_files && state_files.length > 0 ? false : true })} ></textarea>
                                {errors.comments && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                            </div>
                            <div style={{marginTop:10, display:"flex", justifyContent: "flex-between", alignItems:"center"}}>
                                <div style={{float:"left", flex:1, paddingRight:10}}>
                                    {state_files && state_files.length > 0 ? state_files.map((img, index)=>{
                                        return(
                                            <div style={{position: "relative", float: "left", marginRight:10}}>
                                                <div style={{cursor:"pointer", color:"#ffffff", position: "absolute", top: "-6px", right:"3px",
                                                    borderRadius:"100%", fontSize:"8px",backgroundColor:"#FF3300", width:"12px", height:"12px", textAlign:"center"}}
                                                    onClick={()=>{removePic(index)}}
                                                >
                                                    <div style={{marginTop:"-5px", fontSize:12}}>x</div>
                                                </div>
                                                <a href={Helper.convertToFileServerPath(img)} target="_blank">
                                                    <img src={Helper.convertToFileServerPath(img)} style={{width:50, height:50, borderRadius:2, marginRight:10}} />
                                                </a>
                                            </div>
                                        )
                                    }): null}
                                </div>
                                <div>
                                    <Button
                                        style={{float:"right",}}
                                        color="default"
                                        onClick={props.onCancel}
                                        disabled={props.isDisabled}
                                        size="sm">
                                        {props.t("cancel")}
                                    </Button>
                                    <Button
                                        style={{float:"right",}}
                                        color="primary"
                                        onClick={() => submitCommentFormRef.current.click()}
                                        disabled={props.isDisabled}
                                        size="sm">
                                        {props.t("send")}
                                    </Button>
                                    {state_files && state_files.length >= 9 ? null : <div style={{float:"right", marginLeft:10, marginRight:10}}>
                                        <Upload {...uploadProps}>
                                            {uploadButton}
                                        </Upload>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <input ref={submitCommentFormRef} type="submit" hidden />
        </form>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        user: state.session.user,
        partnerId: state.session.partner ? state.session.partner.id : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: vo => dispatch(Actions.loadScreenViewAsync(vo)),
        replyAsync: vo => dispatch(Actions.replyAsync(vo)),
        deleteAsync: vo => dispatch(Actions.deleteAsync(vo)),
        likeAsync: (vo) => dispatch(Actions.likeAsync(vo)),
        deleteLikeAsync: (vo) => dispatch(Actions.deleteLikeAsync(vo)),
        setMessageId: (value) => dispatch(Actions.setMessageId(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(MessageScreen));
